
import { defineComponent, reactive, ref } from "vue";
import { Roles } from "@/store/enums/StoreEnums";
import { hideModal } from "@/core/helpers/dom";
import { useStore } from "vuex";
import { ElMessage, ElMessageBox, FormInstance, FormRules } from "element-plus";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

interface DataForm {
  id: number | null;
  cTenNhomQuyen: string | null;
  cMoTa: string | null;
}

export default defineComponent({
  name: "kt-modal-roles",
  props: {
    data: Object,
    type: Number,
    default: Object,
  },
  emits: ["finish"],
  components: {},
  setup(props) {
    const dataForm = reactive<DataForm>(props.data as DataForm);
    const defaultValues = reactive<DataForm>(props.default as DataForm);
    const store = useStore();
    const formRef = ref<FormInstance>();
    const rolesModalRef = ref<null | HTMLElement>(null);
    const clearForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.resetFields();
    };
    const rules = reactive<FormRules<DataForm>>({
      cTenNhomQuyen: [
        {
          required: true,
          message: "Bạn chưa nhập tên nhóm quyền",
          trigger: "blur",
        },
      ],
      cMoTa: [
        {
          required: true,
          message: "Bạn chưa nhập mô tả",
          trigger: "blur",
        },
      ],
    });
    return {
      formRef,
      rolesModalRef,
      defaultValues,
      dataForm,
      store,
      rules,
      clearForm,
    };
  },
  computed: {
    title() {
      if (this.$props.type == 1) {
        return "Chỉnh sửa nhóm";
      }
      return "Thêm nhóm quyền";
    },
  },
  methods: {
    async handleClose() {
      let DV = this.defaultValues;
      let DF = this.dataForm;
      let check = false;
      for (let prop in DF) {
        check = false;
        if (DF[prop] != DV[prop] && prop != "id") {
          check = true;
          break;
        }
      }
      if (check == true)
        ElMessageBox.confirm(
          "Những thay đổi của bạn sẽ không được lưu lại, bạn có chắc muốn thoát ?"
        )
          .then(async () => {
            this.clearForm(this.formRef);
            hideModal(this.rolesModalRef);
          })
          .catch((err) => {
            console.log(err);
          });
      else hideModal(this.rolesModalRef);
    },
    handleSave() {
      this.formRef?.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.dataForm);
          this.store.dispatch(Roles.saveRole, params).then((res) => {
            if (res.code == 200) {
              Swal.fire({
                text: this.title + " thành công",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Tiếp tục!",
                customClass: {
                  confirmButton: "btn fw-bold btn-light-primary",
                },
              }).then(() => {
                this.$emit("finish");
                hideModal(this.rolesModalRef);
              });
              this.$emit("finish");
            } else {
              if (this.type == 0)
                ElMessage({
                  message: "Thêm nhóm quyền không thành công",
                  type: "error",
                });
              else
                ElMessage({
                  message: "Sửa nhóm quyền không thành công",
                  type: "error",
                });
            }
          });
        }
      });
    },
  },
});
